// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderUploadErrorsModalStyles } from "@insite/content-library/Components/OrderUploadErrorsModal";
import { css } from "styled-components";

orderUploadErrorsModalStyles.modal = {
    sizeVariant: "large",
    cssOverrides: {
        modalTitle: css`
            padding: 20px 20px 10px;
            & > h4 {
                margin-bottom: 0;
            }
        `,
        modalContent: css`
            padding: 20px;
            overflow: auto;
        `,
    },
};

orderUploadErrorsModalStyles.errorMessagesModal = {
    sizeVariant: "medium",
    cssOverrides: {
        modalTitle: css`
            padding: 20px 20px 10px;
            & > h4 {
                margin-bottom: 0;
            }
        `,
        modalContent: css`
            padding: 20px;
        `,
    },
};

orderUploadErrorsModalStyles.reasonCell = {
    css: css`
        font-size: 13px;
        line-height: 16px;
    `,
};
